import { render } from "./UserDashboardVie.vue?vue&type=template&id=019ba07a&scoped=true"
import script from "./UserDashboardVie.vue?vue&type=script&lang=js"
export * from "./UserDashboardVie.vue?vue&type=script&lang=js"

import "./UserDashboardVie.vue?vue&type=style&index=0&id=019ba07a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019ba07a"]])

export default __exports__